"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var logo_blue_svg_1 = __importDefault(require("../../assets/images/logo-blue.svg"));
exports.Header = function (props) {
    var children = props.children, upperContent = props.upperContent, _a = props.logo, logo = _a === void 0 ? { image: logo_blue_svg_1.default, link: "/" } : _a;
    var classes = useStyles(props);
    return (react_1.default.createElement(core_1.AppBar, { position: "fixed", color: "default", elevation: 0, className: classes.appBar },
        upperContent && (react_1.default.createElement(core_1.Toolbar, { variant: "dense", className: classes.upperBar, disableGutters: true },
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 4, wrap: "nowrap" },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(core_1.Typography, { variant: "body2" }, upperContent.text)),
                upperContent.links.map(function (_a, index) {
                    var label = _a.label, href = _a.href;
                    return (react_1.default.createElement(core_1.Grid, { item: true, key: index },
                        react_1.default.createElement(core_1.Link, { href: href, variant: "body2", color: "textSecondary" }, label)));
                })))),
        react_1.default.createElement(core_1.Toolbar, { className: classes.mainBar, disableGutters: true },
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 4, wrap: "nowrap" },
                logo && (react_1.default.createElement(core_1.Grid, { item: true, className: classes.logo },
                    react_1.default.createElement(core_1.Link, { href: logo.link },
                        react_1.default.createElement("img", { src: logo.image, alt: "SwagUp logo" })))),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, className: classes.content }, children)))));
};
var useStyles = styles_1.makeStyles(function (theme) {
    var _a, _b, _c;
    return ({
        appBar: {},
        upperBar: (_a = {
                minHeight: 40,
                paddingLeft: 115,
                paddingRight: 115,
                backgroundColor: "#FAFAFA",
                "& .MuiLink-root": {
                    width: 60,
                }
            },
            _a[theme.breakpoints.down("sm")] = {
                display: "none",
            },
            _a),
        mainBar: (_b = {
                minHeight: 100,
                paddingLeft: 115,
                paddingRight: 115
            },
            _b[theme.breakpoints.down("sm")] = {
                minHeight: 64,
                paddingLeft: 40,
                paddingRight: 40,
            },
            _b[theme.breakpoints.only("xs")] = {
                paddingLeft: 24,
                paddingRight: 12,
            },
            _b),
        logo: {
            "& > a": (_c = {
                    height: "100%",
                    display: "flex",
                    "& > img": {
                        width: 168,
                    }
                },
                _c[theme.breakpoints.down("sm")] = {
                    "& > img": {
                        width: 128,
                    },
                },
                _c),
        },
        content: {},
    });
});
